var _path, _g, _defs;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgChooseusLoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.3691C0 7.08487 6.71573 0.369141 15 0.369141H40V25.3691C40 33.6534 33.2843 40.3691 25 40.3691H0V15.3691Z",
    fill: "url(#paint0_linear_1523_3662)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1523_3662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.1768 30.9017L30.3997 25.5691H28.4497L29.5326 30.7691H10.4668L11.5497 25.5691H9.59965L7.82125 30.9017C7.37015 32.2589 8.16965 33.3691 9.59965 33.3691H30.3997C31.8297 33.3691 32.6292 32.2589 32.1768 30.9017ZM26.4997 13.8691C26.4997 12.1452 25.8148 10.4919 24.5958 9.27295C23.3769 8.05396 21.7236 7.36914 19.9997 7.36914C18.2757 7.36914 16.6224 8.05396 15.4035 9.27295C14.1845 10.4919 13.4997 12.1452 13.4997 13.8691C13.4997 20.0766 19.9997 26.8691 19.9997 26.8691C19.9997 26.8691 26.4997 20.0766 26.4997 13.8691ZM16.4897 13.9471C16.4897 13.4863 16.5805 13.0299 16.7569 12.6041C16.9333 12.1783 17.1918 11.7915 17.5178 11.4657C17.8437 11.1398 18.2307 10.8814 18.6565 10.7052C19.0824 10.5289 19.5388 10.4383 19.9997 10.4384C20.9304 10.4384 21.823 10.8082 22.4811 11.4663C23.1393 12.1244 23.509 13.0171 23.509 13.9478C23.509 14.8785 23.1393 15.7711 22.4811 16.4293C21.823 17.0874 20.9304 17.4571 19.9997 17.4571C19.0687 17.4571 18.176 17.0873 17.5177 16.4291C16.8595 15.7708 16.4897 14.8781 16.4897 13.9471Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1523_3662",
    x1: 4.5,
    y1: 4.86914,
    x2: 52.5,
    y2: 52.8691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.190625,
    stopColor: "#36B4E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753125,
    stopColor: "#0275BC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1523_3662"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(7 7.36914)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChooseusLoc);
export default __webpack_public_path__ + "static/media/chooseus-loc.88b2f0c83648bc18dcc9dea7e02ceada.svg";
export { ForwardRef as ReactComponent };